import "../css/loading.css"
export default function Loading() {
    return (
        <div className="box">
            <div className="spin">
                <span></span>
                <span></span>
                <span></span>
            </div>
        </div>
    )
}